"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var goHomeButtonStyles = styles_1.makeStyles(function (theme) { return ({
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        flexGrow: 1,
        margin: theme.spacing(2) + " 0 " + theme.spacing(4) + " 0",
    },
    button: {
        borderRadius: '4px',
        fontWeight: 'bold',
        padding: '6px 16px',
    },
}); }, { name: 'Checkout_ConfirmationGoHome' });
exports.default = goHomeButtonStyles;
